<template>
	<div class="mabang-panel">
		<el-container style="height: 100%">
			<el-header class="flex-div" style="padding: 0" height="auto">
				<div class="mgr15 mgb10">
					<el-input
						v-model="searchVal"
						style="width: 300px"
						placeholder="运单号，关联运单号，转单号搜索"
					></el-input>
				</div>
				<div class="mgr15">
					<el-button type="primary" @click="search">搜索</el-button>
				</div>
				<div class="mgb10">
					状态：
					<el-select v-model="status" @change="changeStatus" placeholder="全部" style="width: 120px">
						<el-option v-for="item in statusAry" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-header>
			<el-main style="padding: 0">
				<el-table
					:data="tableData"
					style="margin-top: 10px"
					:header-cell-style="{ background: '#eef1f6' }"
					v-loading="loading"
				>
					<el-table-column
						v-for="(item, idx) in tabColumn"
						:key="idx"
						:prop="item.prop"
						:label="item.label"
						:align="item.align"
					>
						<template slot-scope="scope">
							<span v-if="item.isStatus">
								<!-- 切换状态显示已付款和待支付 -->
								{{ scope.row[item.prop] == 2 ? '待支付' : '已支付' }}
							</span>
							<span v-else>
								{{ scope.row[item.prop] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<!-- 根据状态判断显示那个按钮 -->
							<el-button
								v-if="scope.row.payStatus == 2"
								@click="orderpay(scope.row)"
								type="text"
								size="small"
								class="pay_btn"
							>
								去支付
							</el-button>
							<el-button v-else @click="orderDetile(scope.row.orderNo)" type="text" size="small">
								查看
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-main>
			<el-footer height="30px" class="text-right">
				<el-pagination
					@size-change="sizeChange"
					@current-change="pageChange"
					:current-page.sync="currentPage"
					:page-sizes="[20, 50, 100]"
					:page-size.sync="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalCount"
				>
				</el-pagination>
			</el-footer>
		</el-container>
	</div>
</template>

<script>
import { getLogistics } from '@/utils/api'
export default {
	data() {
		return {
			status: null,
			statusAry: [
				{
					label: '全部',
					value: null,
				},
				{
					label: '已支付',
					value: 1,
				},
				{
					label: '待支付',
					value: 2,
				},
			],
			tableData: [
				{
					id: 0,
				},
			],
			searchVal: null,
			totalCount: 0,
			isLoading: false,
			tabColumn: [
				{
					prop: 'created_at',
					label: '创建时间',
					align: 'left',
				},
				{
					prop: 'waybillNum',
					label: '运单号',
					align: 'center',
				},
				{
					prop: 'relatedWayBill',
					label: '关联运单号',
					align: 'center',
				},
				{
					prop: 'transferNum',
					label: '转单号',
					align: 'center',
				},
				{
					prop: 'serverType',
					label: '服务类型',
					align: 'center',
				},
				{
					prop: 'country',
					label: '发往国家',
					align: 'center',
				},
				{
					prop: 'amount',
					label: '订单总金额',
					align: 'center',
				},
				{
					prop: 'payStatus',
					label: '付款状态',
					align: 'center',
					isStatus: true,
				},
			],
			currentPage: 1,
			loading: false,
			pageSize: 20,
		}
	},
	mounted() {
		this.getOrderList()
	},
	methods: {
		search() {
			this.currentPage = 1
			this.getOrderList()
		},
		sizeChange() {
			this.currentPage = 1
			this.getOrderList()
		},
		pageChange() {
			this.getOrderList()
		},
		orderpay(row) {
			this.$router.push({
				path: '/pay',
				query: {
					orderNo: row.orderNo,
				},
			})
		},
		orderDetile(orderId) {
			this.$router.push({
				path: '/logistics-order-detail',
				query: {
					orderId: orderId,
				},
			})
		},
		changeStatus() {
			this.currentPage = 1
			this.getOrderList()
		},
		getOrderList() {
			let params = {
				keyword: this.searchVal == '' ? null : this.searchVal,
				status: this.status,
				page: this.currentPage,
				perPage: this.pageSize,
			}
			getLogistics(params)
				.then((res) => {
					this.tableData = res.data
					this.totalCount = res.total
				})
				.catch(() => {
					this.tableData = []
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.pay_btn {
	color: #e69752;
}
</style>
